import React, { useState } from 'react';
import EventsCalendar from 'components/EventsCalendar';
import PageLayout from 'components/PageLayout';
import useOrganizationDashboard from './hooks/useOrganizationDashboard';
import PageSkeleton from 'components/PageSkeleton';
import OrgAdminLayout from 'screens/organizations/components/OrgAdminLayout';
import dayjs from 'dayjs';

const OrganizationDashboard = () => {
  const [dateRange, setDateRange] = useState({
    afterStartDate: dayjs().startOf('month').toISOString(),
    beforeStartDate: dayjs().endOf('month').toISOString()
  });

  const {
    data: {
      events,
      isLoading: isLoadingEvents,
      isLoadingOrganizationLoading,
      organization
    }
  } = useOrganizationDashboard(
    dateRange.afterStartDate,
    dateRange.beforeStartDate
  );

  if (isLoadingOrganizationLoading || isLoadingEvents) {
    return <PageSkeleton />;
  }

  const handleMonthChange = (startDate: string, endDate: string) => {
    // This will trigger a refetch of the event because the useEffect hook inside of  useOrganizationDashboard is monitoring changes to afterStartDate and beforeStartDate.
    setDateRange({ afterStartDate: startDate, beforeStartDate: endDate });
  };

  return (
    <OrgAdminLayout>
      <PageLayout
        isAdmin={organization?.isUserAdmin}
        isUserMember={organization?.isUserMember}
      >
        <EventsCalendar
          eventList={events}
          isLoading={isLoadingOrganizationLoading || isLoadingEvents}
          organizationId={organization?.id}
          onMonthChange={handleMonthChange}
          isAdmin={organization?.isUserAdmin}
        />
      </PageLayout>
    </OrgAdminLayout>
  );
};

export default OrganizationDashboard;
